const config = {
    backendUrl: process.env.REACT_APP_BACKEND_URL ?? ''
};

export default config;
